var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQdrantIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 64,
    fill: "none",
    viewBox: "0 0 57 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dc244c",
    d: "M28.335 0 .62 16v32l27.714 16 10.392-6V46l-10.392 6-17.32-10V22l17.32-10 17.32 10v40l10.393-6V16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc244c",
    d: "M17.943 26v12l10.392 6 10.392-6V26l-10.392-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0c3e",
    d: "M38.727 46v12l-10.392 6V52zm17.321-30v40l-10.393 6V22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff516b",
    d: "m56.048 16-10.393 6-17.32-10-17.32 10L.62 16 28.335 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc244c",
    d: "M28.335 52v12L.62 48V16l10.394 6v20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff516b",
    d: "m38.727 26-10.392 6-10.392-6 10.392-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc244c",
    d: "M28.335 32v12l-10.392-6V26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0c3e",
    d: "M38.727 26v12l-10.392 6V32z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.332 0h56v64h-56z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQdrantIcon);
export default __webpack_public_path__ + "static/media/qdrantIcon.e74522111b29f2e144b67434fbfa6bf8.svg";
export { ForwardRef as ReactComponent };